import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import { actionTypes, apiStatuses, CancelPayment, Deferred } from "./Actions";

const cancelPayment: CancelPayment = (
  owningClient,
  spidId,
  sig,
  cause
) => dispatch => {
  const deferred: Deferred<CancelPayment> = new Deferred<CancelPayment>();
  const failedCallback = (data: any) => {
    dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.CANCEL_PAYMENT
    });
    return deferred.reject(data);
  };
  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.CANCEL_PAYMENT
  });
  fetchWithUuid(
    `/bestilling/c/${owningClient}/api/v2/ff/users/${spidId}/cancelOrder.json`,
    {
      body: JSON.stringify({
        cause
      }),
      headers: {
        'x-score-spid-sig': sig
      },
      method: 'PUT'
    }
  )
    .then(checkError)
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.CANCEL_PAYMENT
      });
      return deferred.resolve(data);
    })
    .catch(failedCallback);

  return deferred.promise;
};

export default cancelPayment;
